import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=634469e0&lang=pug&"
import script from "./GroupView.vue?vue&type=script&lang=ts&"
export * from "./GroupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports